import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_view = _resolveComponent("router-view");
    const _component_g_cookie_consent = _resolveComponent("g-cookie-consent");
    const _component_g_modal_container = _resolveComponent("g-modal-container");
    const _component_portal_target = _resolveComponent("portal-target");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        (_ctx._layout)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx._layout), {
                key: 0,
                "width-mode": _ctx._widthMode,
                "meta-data": _ctx._meta
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_router_view)
                ]),
                _: 1
            }, 8, ["width-mode", "meta-data"]))
            : _createCommentVNode("", true),
        _createVNode(_component_g_cookie_consent),
        _createVNode(_component_g_modal_container),
        _createVNode(_component_portal_target, { name: "overlay-container" })
    ], 64));
}
